import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { Frame } from '@/components/frame'
import { PageHeader } from '@/components/page-header'
import { PortalInboxList } from '@/components/portal/portal-inbox-list'
import { SegmentedControl } from '@/components/segmented-control'
import { Button } from '@/components/ui/button'
import { useMarkInboxRead, usePortalUnread } from '@/hooks/use-portal-inbox'
import { msg } from '@/i18n'
import { exactly, integer, readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/portal/notifications')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        /** Absent : toutes. */
        filtre: exactly('non-lues'),
        /** Absente : la première. */
        page: integer({ min: 2 }),
      },
      search,
    ),
  component: PortalNotifications,
})

const PAGE_SIZE = 20

/** Toute la cloche (lot 28), la plus récente d'abord, avec le filtre « Non lues ». */
function PortalNotifications() {
  const search = Route.useSearch()
  const unreadOnly = search.filtre === 'non-lues'
  const navigate = useNavigate({ from: Route.fullPath })
  const unread = usePortalUnread()
  const markRead = useMarkInboxRead()
  const count = unread.data?.unread ?? 0
  const t = msg().portalHome.bell

  return (
    <div className="space-y-4">
      <PageHeader title={t.title} documentTitle={t.title} />
      <Frame>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <SegmentedControl
            label={t.show}
            value={unreadOnly ? 'non-lues' : 'toutes'}
            options={[
              { value: 'toutes', label: t.all },
              { value: 'non-lues', label: t.unreadFilter(count) },
            ]}
            onChange={(value) => {
              void navigate({ search: value === 'non-lues' ? { filtre: value } : {} })
            }}
          />
          {count > 0 && (
            <Button
              variant="outline"
              size="sm"
              disabled={markRead.isPending}
              onClick={() => {
                markRead.mutate({ all: true })
              }}
            >
              {t.markAllRead}
            </Button>
          )}
        </div>
        <PortalInboxList
          pageSize={PAGE_SIZE}
          page={search.page ?? 1}
          unreadOnly={unreadOnly}
          onPageChange={(next) => {
            void navigate({
              search: (previous) => ({ ...previous, page: next > 1 ? next : undefined }),
            })
          }}
        />
      </Frame>
    </div>
  )
}
